import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AutenticacaoService } from 'app/services/autenticacao.service';
import { StorageService } from 'app/services/storage.service';
import { KeysStorage } from './keys-storage';
import { HostnameService } from 'app/services/hostname.service';
import { environment } from 'environments/environment';

/**
 * Guard that protects routes requiring an active plan.
 *
 * Order of checks:
 *   1. Not authenticated            → /login
 *   2. Trial still valid            → allow (no subscription needed yet)
 *   3. Subscription active (2)      → allow
 *   4. Everything else (trial expired + no active subscription) → /assinatura
 */
export const planoAtivoGuard: CanActivateFn = () => {
    const autenticacaoService = inject(AutenticacaoService);
    const storage = inject(StorageService);
    const router = inject(Router);
    const hostnameService = inject(HostnameService);

    if (!autenticacaoService.isAuthenticated()) {
        if (environment.production && !hostnameService.isAppDomain()) {
            window.location.href = hostnameService.getAppUrl('/login');
            return false;
        }
        router.navigateByUrl('/login');
        autenticacaoService.logout();
        return false;
    }

    const dataFimTrialStr = storage.get(KeysStorage.dataFimTrial());
    const statusAssinaturaStr = storage.get(KeysStorage.statusAssinatura());

    // No trial info → subscription-only account or data missing; let through
    if (!dataFimTrialStr) {
        return true;
    }

    const trialExpirado = new Date(dataFimTrialStr) < new Date();

    if (!trialExpirado) {
        return true; // Trial still active
    }

    const statusAtivo = statusAssinaturaStr === '2'; // StatusAssinatura.Ativa = 2

    if (statusAtivo) {
        return true; // Paid subscription active
    }

    router.navigateByUrl('/assinatura');
    return false;
};
